"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DepositSelectionResponse = exports.DepositPolicyChargesResponse = exports.DepositOptionCharges = void 0;
var DepositOptionCharges = /** @class */ (function () {
    function DepositOptionCharges() {
        this.enrollmentFee = '';
        this.premiumAmount = '';
        this.premiumFor = '';
    }
    return DepositOptionCharges;
}());
exports.DepositOptionCharges = DepositOptionCharges;
var DepositPolicyChargesResponse = /** @class */ (function () {
    function DepositPolicyChargesResponse() {
        this.success = false;
    }
    return DepositPolicyChargesResponse;
}());
exports.DepositPolicyChargesResponse = DepositPolicyChargesResponse;
var DepositSelectionResponse = /** @class */ (function () {
    function DepositSelectionResponse() {
        this.success = false;
    }
    return DepositSelectionResponse;
}());
exports.DepositSelectionResponse = DepositSelectionResponse;
